import Cookies from "js-cookie";
function makeauth() {
    Cookies.set("auth", "true");
}
function removeauth() {
    Cookies.remove("auth");
}
export default {
    makeauth,
    removeauth,
};
